import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {QueryParam, Utils} from "lib-base";
import {INucleoFamiliar} from "../shared/interface/sisben";
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class NucleoFamiliarService {
  private readonly baseUrl: string = `${environment.apiUrl}/api/nucleo-familiar`;

  constructor(private http: HttpClient) {
  }

  getJefeFamiliaByTipoIdAndDNI(tipoIdentificacion: string, identificacion: string): Observable<INucleoFamiliar> {
    const params: QueryParam[] = [
      {key: 'tipoIdentificacion', value: tipoIdentificacion},
      {key: 'identificacion', value: identificacion},
    ];
    return this.http.get<INucleoFamiliar>(Utils.createQueryParams(`${this.baseUrl}/jefe-hogar`, params))
  }

  getNucleoFamiliar(jefeFamilia:number): Observable<INucleoFamiliar[]> {
    return this.http.get<INucleoFamiliar[]>(`${this.baseUrl}/nucleo-familiar/${jefeFamilia}`);
  }

}
